const projects = {
  projects: {
    header: {
      overline: "PORTFOLIO & RECHERCHE",
      titlePrefix: "Solutions",
      titleHighlight: "innovantes",
      subtitle: "Une sélection de projets en production et de labs R&D pour repousser les limites de l’IA.",
    },
    tabs: {
      all: "Tout",
      projects: "Projets",
      labs: "Labs",
    },
    card: {
      code: "Code",
      demo: "Démo",
    },
    cta: {
      titlePrefix: "Prêt à concrétiser votre",
      titleHighlight: "vision IA ?",
      subtitle:
        "Projet en production ou lab expérimental : je vous aide à transformer des données complexes en solutions intelligentes.",
      primaryButton: "Lancer un projet",
      secondaryButton: "Voir les services",
    },
  },
};

export default projects;
